const employeesData = [
    {
      id: 1,
      firstName: 'Utkarsh',
      lastName: 'Anand',
      email: 'anand@example.com',
      salary: '85000',
      date: '2019-04-11'
    },
    {
      id: 2,
      firstName: 'Arsh',
      lastName: 'Anand',
      email: 'arsh@example.com',
      salary: '80000',
      date: '2019-04-17'
    },
    {
      id: 3,
      firstName: 'Ark',
      lastName: 'Ekansh',
      email: 'arkf@example.com',
      salary: '79000',
      date: '2019-05-01'
    },
    {
      id: 4,
      firstName: 'Arth',
      lastName: 'Ekansh',
      email: 'arth@example.com',
      salary: '56000',
      date: '2019-05-03'
    },
    {
      id: 5,
      firstName: 'Vivek',
      lastName: 'Anand',
      email: 'vivek@example.com',
      salary: '65000',
      date: '2019-06-13'
    },
    {
      id: 6,
      firstName: 'Ankit',
      lastName: 'Gupta',
      email: 'ankit@example.com',
      salary: '120000',
      date: '2019-07-30'
    },
    {
      id: 7,
      firstName: 'Gaurav',
      lastName: 'Gupta',
      email: 'gaurav@example.com',
      salary: '90000',
      date: '2019-08-15'
    },
    {
      id: 8,
      firstName: 'Chandransh',
      lastName: 'Gaur',
      email: 'chandu@example.com',
      salary: '60000',
      date: '2019-10-10'
    },
    {
      id: 9,
      firstName: 'Shikha',
      lastName: 'Pandey',
      email: 'shikha@example.com',
      salary: '71000',
      date: '2019-10-15'
    },
    {
      id: 10,
      firstName: 'Shivani',
      lastName: 'Yadav',
      email: 'shivani@example.com',
      salary: '110000',
      date: '2020-01-15'
    }
  ];
  
  export { employeesData };